export const NAMESPACE = '_persisted';

export const INITIAL_STATE = {
  success: false,
  error: null,
  persistedStores: [],
  appId: null,
  finalized: false,
};
